module.exports = ".mat-progress-spinner {\n  display: inline-block;\n  vertical-align: middle; }\n\n.message {\n  margin-left: 0.5em; }\n\n.image {\n  width: 40px;\n  height: 40px;\n  -webkit-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite; }\n\n@-webkit-keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg); } }\n\n@keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg); } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/loader/loader.component.scss
// module id = ./src/app/loader/loader.component.scss
// module chunks = main